import { render, staticRenderFns } from "./ModuleCreateWalletSoftware.vue?vue&type=template&id=748e52a2&"
import script from "./ModuleCreateWalletSoftware.vue?vue&type=script&lang=js&"
export * from "./ModuleCreateWalletSoftware.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports